import {NgModule, Pipe, PipeTransform} from "@angular/core";

@Pipe({name: "join"})
export class JoinPipe implements PipeTransform {

    transform(input: Array<any>, sep = ',', property?: string): string {
        let array = input;
        if (property) {
            array = input.map(value => value[property]);
        }
        return array.join(sep);
    }
}

@NgModule({
    declarations: [
        JoinPipe,
    ],
    exports: [
        JoinPipe
    ]
})
export class JoinPipeModule {
}